import { _event } from "../utils/_event";
import { _localStyle } from "../utils/_localStyle";
import { _parallax } from "../utils/_parallax";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

class Header extends MainClass {
    adminbar: HTMLElement | null;
    lastScrollY: number;

    constructor(options: MAIN_CLASS_PARAMS) {
        super(options);

        this.adminbar = document.querySelector("#wpadminbar") as HTMLElement;
        this.lastScrollY = window.pageYOffset || document.documentElement.scrollTop;

        this.init();
    }

    init() {
        _localStyle();

        this.scroller();
        this.toggleTheme();
        this.toggleMobileMenu();
    }

    scroller() {
        _event.resize(() => {
            if (getComputedStyle(document.body).overflow == "hidden") return;

            this.selector.style.paddingTop = "";
            if (this.adminbar) this.selector.style.paddingTop = `${this.adminbar.offsetHeight}px`;

            document.body.style.setProperty("--header-height", `${this.selector.offsetHeight}px`);
        });

        _event.scroll(() => {
            if (getComputedStyle(document.body).overflow == "hidden") return;

            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

            if (this.lastScrollY === currentScrollY) return;

            if (currentScrollY > this.lastScrollY - 1) {
                // scroll down
                if (currentScrollY <= Math.max(this.selector.offsetHeight * 0.25, 10)) return;
                this.selector.classList.add("opacity-0", "pointer-events-none");
            } else {
                // scroll up
                this.selector.classList.remove("opacity-0", "pointer-events-none");
            }

            this.lastScrollY = currentScrollY;
        });
    }

    toggleTheme() {
        this.selector.style.setProperty("--duration", "0.1s");

        let _height = document.body.offsetHeight;

        let _sections = [
            ...document.querySelectorAll("[data-section-theme]"),
            ...document.querySelectorAll(".section-wrapper"),
            ...document.querySelectorAll(".section"),
            ...document.querySelectorAll('[class*="wp-block-section"]'),
        ];

        _sections = _sections.filter((item, index, self) => self.indexOf(item) === index);

        const _offsets: { target: HTMLElement; offset: { top: number; bottom: number } }[] = [];

        _sections.forEach((item) => {
            _offsets.push({ target: item as HTMLElement, offset: { top: 0, bottom: 0 } });
        });

        const _resize = () => {
            _offsets.forEach((item) => {
                const _offset = _parallax.getOffset(item.target);

                item.offset.top = _offset.top;
                item.offset.bottom = _offset.bottom;
            });

            _height = document.body.offsetHeight;
        };

        _event.resize(() => {
            _resize();
        });

        let _themeTimeOut: ReturnType<typeof setTimeout> = null as any;
        const _update = (dark = false) => {
            if (dark) {
                this.selector.classList.add("dark");
            } else {
                this.selector.classList.remove("dark");
            }

            this.selector.classList.add("theme-transition");

            clearTimeout(_themeTimeOut);

            _themeTimeOut = setTimeout(() => {
                this.selector.classList.remove("theme-transition");
            }, 200);
        };

        _event.scroll(() => {
            if (_height !== document.body.offsetHeight) _resize();

            const _scrollY = window.scrollY + this.selector.offsetHeight * 0.5;

            const _inview = _offsets.find((item) => {
                return _scrollY >= item.offset.top && _scrollY <= item.offset.bottom;
            });

            const _darkTheme =
                _inview &&
                (_inview.target.dataset.sectionTheme?.toLowerCase() === "dark" ||
                    (!_inview.target.dataset.sectionTheme && _inview.target.classList.contains("dark")));

            _update(_darkTheme);
        });
    }

    toggleMobileMenu() {
        const mobileMenuToggle = document.querySelector(".js-header-component-mobile-menu-toggle") as HTMLInputElement;
        const mobileMenu = document.querySelector(".js-header-component-mobile-menu") as HTMLInputElement;
        const body = document.querySelector("body") as HTMLElement;
        mobileMenuToggle?.addEventListener("change", (e) => {
            const target = e.target as HTMLInputElement;
            if (target.checked) {
                mobileMenu?.classList.add("!translate-y-0");
                body?.classList.add("overflow-hidden");
            }
            if (!target.checked) {
                mobileMenu?.classList.remove("!translate-y-0");
                body?.classList.remove("overflow-hidden");
            }
        });
    }
}

export default Header;
